import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { logger } from './lib/logger'
import { startMocks } from './mocks/start'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found in document')

// Start the MSW mock (dev + VITE_MOCK_DATA) before first render so seeded data is
// available immediately; no-op in production. Render regardless of mock startup —
// a failed worker registration must not leave a blank page; the app falls back to
// the real API.
function render() {
	createRoot(rootElement as HTMLElement).render(
		<StrictMode>
			<App />
		</StrictMode>,
	)
}

startMocks()
	.catch((err) => {
		logger.error('MSW mock failed to start; falling back to the real API.', err)
	})
	.finally(render)
